export default "skymp5-front/ebcbd62ad04a39e5b3918c0a91e33ace.png";